// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._8c734d{counter-reset:subtask}._233ecd{align-self:center}._233ecd svg{margin-right:.5em;opacity:.25;margin-left:-0.5em;cursor:grab;color:var(--secondary)}._233ecd:after{counter-increment:subtask;content:counter(subtask) \".\";margin-right:.25em}._47cfb4{text-decoration:line-through;color:var(--secondary)}", ""]);
// Exports
exports.locals = {
	"list": "_8c734d",
	"prefix": "_233ecd",
	"completed": "_47cfb4"
};
module.exports = exports;
